import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs/Rx';
import { CursosService } from './shared/cursos.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { StringUtilsService } from 'app/shared/string-utils.service';

import { Campus } from 'models/campus';
import { Curso } from 'models/curso';
import { environment } from '../../../environments/environment';

// Cursos por página
const POR_PAGINA = 200;

const AREAS_CONHECIMENTO = [
  { nome: 'Humanas', key: 'humanas' },
  { nome: 'Exatas', key: 'exatas' },
  { nome: 'Saúde', key: 'saude' },
];

const verificaValidadeArea = (area) => AREAS_CONHECIMENTO.filter(_area => _area.key === area).length === 1;
const verificaAreaPorArray = (params) => params.length > 1 && verificaValidadeArea(params[1]);

@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.scss'],
})
export class CursosComponent implements OnInit, OnDestroy {

  environment = environment;
  inscricaoRota;
  situacaoModal = new Subject();
  configuracaoPaginacao = new Subject();
  areaConhecimento = AREAS_CONHECIMENTO;
  modelOptions = { standalone: true };
  courseIsDireito: boolean = false;

  query = {
    campus: null,
    curso: null,
    areaConhecimento: null,
    modalidade: null,
    palavraChave: null,
    presencial: null,
    pagina: 1,
  };

  carregandoCursos: boolean;
  cursos: Curso[] = [];
  campis: Campus[] = [];

  turnos = {
    M: 'manha',
    V: 'tarde',
    N: 'noite',
    I: 'manha',
  };

  constructor(
    private router: Router,
    private cursosService: CursosService,
    private analytics: AnalyticsService,
    private stringUtil: StringUtilsService,
  ) {
    this.inscricaoRota = router.events.subscribe(
      (evt) => evt instanceof NavigationEnd && this.onNavegacaoURL(evt.url),
    );
  }

  private filtroAtuacaoPorURL(url) {
    url = this.stringUtil.urlParaArray(url);
    this.query.areaConhecimento = verificaAreaPorArray(url) ? url[1] : null;
  }

  private onNavegacaoURL(url) {
    this.filtroAtuacaoPorURL(url);
    this.buscarCursos(this.query);
  }

  ngOnInit() {
    this.buscarCampus();
  }

  ngOnDestroy() {
    if (this.inscricaoRota) {
      this.inscricaoRota.unsubscribe();
    }
  }

  buscarCursos(params) {
    this.carregandoCursos = true;
    params.porPagina = POR_PAGINA;

    this.cursosService.query(params).then((data) => {
      this.carregandoCursos = false;
      this.cursos = data.data.sort((a, b) => a.nome > b.nome ? 1 : -1);
      this.situacaoModal.next(false);

      this.configuracaoPaginacao.next({
        total: data.total,
        porPagina: params.porPagina,
        atual: params.pagina,
      });
    });
  }

  async buscarCampus() {
    const pegaCampus = await this.cursosService.campus();
    this.campis = pegaCampus.filter(campus => campus.nome !== "Anil" && campus.nome !== "Cohama")
  }

  clickCurso(curso) {
    this.analytics.registrar('Curso Graduação', 'click', curso.nome);
  }

  gerarLinkCurso(curso) {
    return `/graduacao/${curso.id}-${this.stringUtil.textoParaSlug(curso.nome)}`;
  }

  traduzirModalidade(alias) {
    return alias === 'N' ? 'EAD' : 'Presencial';
  }

  navegacaoPaginacao(paginacao) {
    this.query.pagina = paginacao.pagina;
    this.buscarCursos(this.query);
  }

  pesquisar() {
    this.buscarCursos(this.query);
  }

  nomeTurnoPorSigla(sigla) {
    return this.turnos[sigla] || '';
  }
}
